// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_status(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "ActiveBuyerNeed",
              "ExpiredBuyerNeed",
              "InContractBuyerNeed",
              "PurchasedBuyerNeed",
              "WithdrawnBuyerNeed"
            ]);
}

var fragmentConverter = {"__root":{"status_ActiveBuyerNeed_activeUntil":{"b":""},"status":{"u":"fragment_status"}}};

var fragmentConverterMap = {
  fragment_status: unwrap_fragment_status
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

var Utils = {};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnBuyerNeedStatusLabel_buyerNeedV5",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRenewable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activeUntil",
                "storageKey": null
              }
            ],
            "type": "ActiveBuyerNeed",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "ExpiredBuyerNeed",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "PurchasedBuyerNeed",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "InContractBuyerNeed",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "WithdrawnBuyerNeed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "BuyerNeedV5",
  "abstractKey": null
};
})());

var wrap_fragment_status = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_status = unwrap_fragment_status;
exports.wrap_fragment_status = wrap_fragment_status;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
